import classNames from 'classnames/bind';
import React from 'react';

import styles from './Logout.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import useAuth from '@/hooks/useAuth';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Modal = () => {
  const { doLogout } = useAuth();

  const close = () => {
    modalManager.hide();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('message')}>Do you really want to logout?</div>
      <div className={cx('bottom')}>
        <PrimaryButton text="Cancel" onClick={close} />
        <PrimaryButton text="Logout" accent onClick={doLogout} />
      </div>
    </ModalWrapper>
  );
};

export default Modal;
